import React from "react";

import { useAppState } from "../../../../../../../context/StateContext";
import { CompanyProfile } from "../../../../../../../util/enums";
import DefaultPreferences from "./components/Default";
import ShipmentTrackingPreference from "./components/ShipmentTracking";

type Props = {
  permission?: {
    edit: boolean,
    create: boolean,
  }
}

const Preferences = ({ permission }: Props) => {
  const { currentUser } = useAppState();

  const getPreferenceScreenByProfile = () => {
    switch (currentUser?.company?.profile?.initials) {
      case CompanyProfile.ST:
        return <ShipmentTrackingPreference />;
      default:
        return <DefaultPreferences permission={permission} />;
    }
  };

  return getPreferenceScreenByProfile();
};

export default Preferences;
